export default "__VITE_ASSET__YYdDpCy2__"